import React from 'react';
import {connect as connectR} from 'react-redux';
import translate from '../translate';
import LargeCard from '../main/large-card';
import _ from 'lodash';
import {RootState} from '../../store';
import {getEmailChangeRequest, RequestConfirmEmailChange,} from '../../store/changeEmailSlice';
import {RequestStatus} from '../../store/network/managedRequest';
import {Button, Col, FormControl, Row} from 'react-bootstrap';
import ValidatorFormGroup from '../main/validator-form-group';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCheckCircle} from '@fortawesome/free-solid-svg-icons';
import {PbGenericRequest} from '../../store/pbRequestSlice';
import {PbRequest} from '../../store/pbRequest';
import {goToLogin} from '../../nav/navigationService';
import withParams from "../../nav/withParams";

interface ChangeEmailLandingPageState {
    code: string;
    changed?: boolean;
}

interface ChangeEmailLandingPageProps {
    strings?: ChangeEmailLandingPageTexts;
    params: {
        code: string;
    };
    loggedInUseEmail?: string;

    confirmChangeEmailRequest: PbGenericRequest;
    getChangeEmailRequest: PbGenericRequest;
    changeEmailData?: {
        user_email: string;
        updated_email: string;
    };
    RequestConfirmEmailChange: (code: string) => void;
    getEmailChangeRequest: (code: string) => void;
}

interface ChangeEmailLandingPageTexts {
    title: string;
    verificationCodeHeader: string;
    confirmButtonText: string;
    reLogin?: string;
    error?: string;
    success?: string;
    notFound?: string;
    currentEmail: string;
    changeEmail: string;
}

interface ChangeEmailLandingPageStateChange {
    code?: string;
}

class ChangeEmailLandingPage extends React.Component<
    ChangeEmailLandingPageProps,
    ChangeEmailLandingPageState
> {
    componentDidMount() {
        this.props.getEmailChangeRequest(this.props.params.code);
    }

    _handleStateChange = (stateChange: ChangeEmailLandingPageStateChange) => {
        const newData = _.extend({}, this.state) as ChangeEmailLandingPageState;
        if (stateChange.code) {
            newData.code = stateChange.code;
        }
        this.setState(newData);
    };

    renderRequestStatus() {
        if (
            this.props.confirmChangeEmailRequest.status ===
            RequestStatus.FAILURE
        ) {
            return (
                <div className="alert alert-danger pull-left">
                    {this.props.strings.error}
                </div>
            );
        } else if (
            this.props.confirmChangeEmailRequest.status ===
            RequestStatus.SUCCESS
        ) {
            return (
                <div>
                    <span style={{ marginRight: '0.2em' }}>
                        <FontAwesomeIcon color={'green'} icon={faCheckCircle} />
                    </span>
                    {this.props.strings.success}
                </div>
            );
        } else {
            return <div />;
        }
    }

    render(): React.ReactElement | null {
        const dataExist =
            this.props.getChangeEmailRequest.status === RequestStatus.SUCCESS;
        const changed =
            this.props.confirmChangeEmailRequest.status ===
            RequestStatus.SUCCESS;
        return (
            <LargeCard title={[this.props.strings.title]}>
                {dataExist && (
                    <div>
                        <Row>
                            <Col xs={12} sm={12} md={12} lg={12}>
                                <div>
                                    <div>
                                        {!this.state.changed && (
                                            <ValidatorFormGroup
                                                label={
                                                    this.props.strings
                                                        .currentEmail
                                                }
                                                hideErrorLabel
                                                errorLabel=""
                                            >
                                                <FormControl
                                                    disabled={true}
                                                    type="text"
                                                    className={`input-text-color`}
                                                    value={
                                                        this.props
                                                            .changeEmailData
                                                            ?.user_email
                                                    }
                                                    name="loggedInUseEmail"
                                                    required
                                                />
                                            </ValidatorFormGroup>
                                        )}
                                        <ValidatorFormGroup
                                            label={
                                                this.props.strings.changeEmail
                                            }
                                            hideErrorLabel
                                            errorLabel=""
                                        >
                                            <FormControl
                                                disabled={true}
                                                type="text"
                                                className={`input-text-color`}
                                                value={
                                                    this.props.changeEmailData
                                                        ?.updated_email
                                                }
                                                name="changeEmail"
                                                required
                                            />
                                        </ValidatorFormGroup>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} sm={12} md={12} lg={12}>
                                {this.renderRequestStatus()}
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} sm={12} md={12} lg={12}>
                                {!changed && (
                                    <Button
                                        type="button"
                                        className="btn btn-primary pull-right"
                                        onClick={() => {
                                            this.props.RequestConfirmEmailChange(
                                                this.props.params.code
                                            );
                                        }}
                                    >
                                        {this.props.strings.confirmButtonText}
                                    </Button>
                                )}
                                {changed && (
                                    <Button
                                        type="button"
                                        className="btn btn-primary pull-right"
                                        onClick={() => {
                                            this.redirectToLogin();
                                        }}
                                    >
                                        {this.props.strings.reLogin}
                                    </Button>
                                )}
                            </Col>
                        </Row>
                    </div>
                )}
                {!dataExist && (
                    <div>
                        <Row>
                            <Col xs={12} sm={12} md={12} lg={12}>
                                <div>
                                    <div>{this.props.strings.notFound}</div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                )}
            </LargeCard>
        );
    }

    redirectToLogin = () => {
        goToLogin();
    };

    state: ChangeEmailLandingPageState = {
        code: '',
    };
}

export default connectR(
    (store: RootState) => ({
        confirmChangeEmailRequest:
            store.pbRequest[PbRequest.CONFIRM_CHANGE_EMAIL],
        getChangeEmailRequest: store.pbRequest[PbRequest.GET_CHANGE_EMAIL],
        changeEmailData: store.changeEmail.changeEmailData,
        loggedInUseEmail: store.user.legacyUser?.email,
    }),
    {
        RequestConfirmEmailChange,
        getEmailChangeRequest,
    }
)(translate('ChangeEmailLandingPage')(withParams(ChangeEmailLandingPage)));
